<template>PaymentStep</template>

<script setup lang="ts"></script>
